Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=





mapKeyState;var _MQTTActions=require('../actions/MQTTActions');function mapKeyState(state){
var storeId=state._mqttRawTopic.split('/')[0].split(':')[1];
if(!storeId){
return null;
}
return(0,_MQTTActions.updateKeyState)(_extends({},

state.toObject()),

storeId);

}